import React, { FC } from 'react'

import WishListContent from '@Domains/Product/Features/WishList/Content'
import WishListEmpty from '@Domains/Product/Features/WishList/Empty'
import { useBlockConfig } from '@Globals/CMS/Context'

interface WishListBlockProps {
  id?: string
}

const WishListBlock: FC<WishListBlockProps> = ({ id }) => {
  const config = useBlockConfig()
  const hits = config?.algolia?.hitsArray || []

  if (hits.length === 0) {
    return (
      <WishListEmpty id={id} />
    )
  }

  return (
    <WishListContent id={id} tiles={hits} />
  )
}

export default WishListBlock
